import styled from 'styled-components';
import { colors } from "../../../constants";
export var LinkColumns = styled.a.withConfig({
  componentId: "sc-12ricn0-0"
})(["color:", ";"], function (_ref) {
  var palette = _ref.palette;
  return colors[palette];
});